module.exports = __webpack_public_path__ + "img/fapiao1.c947345e.png";